import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Flex, Text } from 'rebass'
import { Backdrop, Overlay } from "reakit";
import { DesktopBox, MobileBoxFaculty, FacultyContactContainer, MobileBoxChat } from "../Base";
import IosArrowForward from "react-ionicons/lib/IosArrowForward";
import styled from "styled-components";

const StyledOverlay = styled(Overlay)`
	min-width: 150px;
	min-height: 110px;
`

const StyledFlex = styled(Flex)`
	min-width: 150px;
	max-height: 110px;
`

const StyledLink = styled.a`
 text-decoration: none;
 height: fit-content;
`

const ChatButton = styled.a`
 width: fit-content;
 align-self: center;
`

const FixedControls = styled(Box)`
  position: relative;
  bottom: -54px;
  width: 100%;
`;

const FacultyContactMethod = props => {
  const { handleChat, profile, noButton } = props;

  return (
    <Overlay.Container>
      {overlay => (
        <FacultyContactContainer>
          <Flex flexDirection={'row'} m={0} p={0} onClick={overlay.show}>
            <MobileBoxFaculty>
              <Flex flexDirection={'row'} m={0} p={0} onClick={overlay.show}>
                <Text mr={1}>Contact </Text>
              </Flex>
            </MobileBoxFaculty>
          </Flex>

          <DesktopBox>
            {noButton ?
              <Flex flexDirection={'row'} mb={4} onClick={overlay.show}>
                <Text mr={1} >Contact </Text>
                <IosArrowForward fontSize={'16px'} color={'#969a9b'} />
              </Flex> : <FixedControls>
                <Button variant={'contact'} onClick={overlay.show}>Contact</Button>
              </FixedControls>
            }

          </DesktopBox>


          <Backdrop fade use={Overlay.Hide} {...overlay} />
          <StyledOverlay fade slide {...overlay} >
            <Flex flexDirection={'column'} justifyContent={'space-between'}>
              <Box pb={3}>
                <Text textAlign={'center'}>How would you like to contact {profile.first_name} {profile.last_name} ?</Text>
              </Box>
              <MobileBoxChat>
                {/*<StyledFlex justifyContent={'center'}>*/}
                  {/*{profile.home_phone && profile.home_phone !== "" &&*/}
                  {/*  <StyledLink href={`tel:${profile.home_phone.split('-').join('')}`}><Button variant={'second'} p={1} m={1} bg='red' onClick={overlay.hide} >Phone</Button></StyledLink>}*/}
                  {/*{profile.mobile && profile.mobile !== "" &&*/}
                  {/*  <StyledLink href={`tel:${profile.mobile.split('-').join('')}`}><Button variant={'second'} p={1} m={1} bg='red' onClick={overlay.hide} >Phone</Button></StyledLink>}*/}
                  <Button variant={'second'} p={1} m={1} bg={'green'} onClick={() => {
                    handleChat()
                    overlay.hide()
                  }}>Chat</Button>
                {/*</StyledFlex>*/}
              </MobileBoxChat>

              <DesktopBox>

                <Flex justifyContent={'center'} flexDirection={'column'}>

                  {/*{profile.home_phone && profile.home_phone !== "" &&*/}
                  {/*  <Fragment>*/}
                  {/*    <Text textAlign={'center'} py={2}>Phone Number:</Text>*/}
                  {/*    <Text textAlign={'center'} variant={'second'} p={1} m={1} >{profile.home_phone}</Text>*/}

                  {/*  </Fragment>}*/}
                  {/*{profile.mobile && profile.mobile !== "" &&*/}
                  {/*  <Fragment>*/}
                  {/*    <Text textAlign={'center'} py={2}>Phone Number:</Text>*/}
                  {/*    <Text textAlign={'center'} variant={'second'} p={1} m={1} >{profile.mobile}</Text>*/}

                  {/*  </Fragment>}*/}
                  {/*<Flex justifyContent={'center'}>*/}
                    <ChatButton>
                      <Button variant={'second'} p={1} m={1} bg={'green'} onClick={() => {
                        handleChat()
                        overlay.hide()
                      }}>Chat</Button>
                    </ChatButton>
                  {/*</Flex>*/}
                </Flex>
              </DesktopBox>

            </Flex>

          </StyledOverlay>
        </FacultyContactContainer>
      )}
    </Overlay.Container>
  );
};

FacultyContactMethod.propTypes = {
  handleConfirm: PropTypes.func,
  toggle: PropTypes.func,
  visible: PropTypes.bool,
  noButton: PropTypes.bool
};

FacultyContactMethod.defaultProps = {
  handleConfirm: () => console.log('clicked confirm delete'),
  visible: false,
  noButton: false
};

export default FacultyContactMethod;
